import { Trans } from '@lingui/macro';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { I18nProviderWrapper } from '@components/common/I18nProviderWrapper';
import BulkShareModal from '@components/show_page/bulk_actions/BulkShareModal';
import { trackAssetInteraction } from '@helpers/amplitude-init';

const ShareAsset = ({ assetKey }) => {
  const [showModal, setShowModal] = useState(false);

  const handleShareClick = (e) => {
    if (!showModal) {
      e.preventDefault();

      // Track with Amplitude
      if (window.BFG?.amplitude?.enabled && window.amplitudeService) {
        trackAssetInteraction('Shared', assetKey, {
          assetId: assetKey,
          share_location: 'modal_action_bar',
        });
      }

      setShowModal((prevState) => (!prevState));
    }
  };

  return (
    <I18nProviderWrapper>
      <button
        className="button secondary sm share-button"
        onClick={handleShareClick}
        type="button"
      >
        <div className="attachment-icon">
          <span aria-hidden="true" className="bff-share" />
        </div>
        <Trans>Share</Trans>
        {showModal && (
          <BulkShareModal
            closeModal={() => setShowModal(false)}
            selectedAssetKeys={new Set([assetKey])}
          />
        )}
      </button>
    </I18nProviderWrapper>
  );
};

ShareAsset.propTypes = {
  assetKey: PropTypes.string.isRequired
};

export default ShareAsset;
